import { PercentageOutlined } from "@ant-design/icons";
import { Col, Form, Input, Row, Select, Spin, Tooltip } from "antd";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { getRequest, patchRequest, postRequest } from "../../../axios";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import InputField from "../../../common/htmlComponents/InputField";
import { ReactComponent as AddressLine } from "../../../image/AddressLine.svg";
import { ReactComponent as CircleIcon } from "../../../image/CircleIcon.svg";
import { SuccessNotificationMsg } from "../../../utils/Notifications";

const AddMaterialType = ({
  handleCancel,
  setReload,
  materialTypeId,
  modalKey,
  setStateM,
}) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const formRef = useRef();

  //State Initalstate
  const initialState = {
    category_tree: null,
    hsn_code: "",
    type_name: "",
    gst_rate: "",
    gst_rate_freight: "",
    estimated_unit_price: "",
    escalation: "",
    sub_category: "",
    specification: "",
    dimension_standard: "",
  };
  const [state, setState] = useState(initialState);
  const [categoryTree, setCategoryTree] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);
  const selectedCategory = categoryTree.find(
    (item) => item.id === state.category_tree
  );
  const selectedCategoryName = selectedCategory?.name;

  //Fetch Material Type by Id
  useEffect(() => {
    const materialTypeGetById = async () => {
      if (materialTypeId !== null) {
        try {
          setapiLoading(true);
          const response = await getRequest(`material-type/${materialTypeId}/`);
          console.log("frespddonse", response);

          const {
            category_tree,
            category_tree_name,
            type_name,
            hsn_code,
            gst_rate,
            gst_rate_freight,
            estimated_unit_price,
            escalation,
            sub_category,
            specification,
            dimension_standard,
          } = response.data.data;
          setState({
            category_tree,
            category_tree_name,
            type_name,
            hsn_code,
            gst_rate,
            gst_rate_freight,
            estimated_unit_price,
            escalation,
            sub_category,
            specification,
            dimension_standard,
          });
          formRef.current.setFieldsValue({
            category_tree,
            type_name,
            hsn_code,
            gst_rate,
            gst_rate_freight,
            estimated_unit_price,
            escalation,
            sub_category,
            specification,
            dimension_standard,
          });
          setapiLoading(false);
        } catch (error) {
          setapiLoading(false);
        }
      }
    };
    materialTypeGetById();
  }, [materialTypeId, modalKey]);

  // This useEffect hook runs once when the component mounts.
  useEffect(() => {
    getCategoryTree(); // Retrieves the category tree data and updates the state.
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        backToList();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  console.log("statexz", state);

  // Fetch Category tree
  const getCategoryTree = async (data) => {
    // await getRequest("category-tree/?no_pagination=True", data).then(
    await getRequest("category-tree/category-tree-list/?no_pagination=True", data).then(
      (response) => {
        setCategoryTree(response.data.data);
      }
    );
  };

  // BAck To List
  const backToList = () => {
    setState(initialState);
    formRef.current.setFieldsValue(initialState);
    handleCancel();
  };

  // Handle Input change
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };
  const handleChange = (name, value) => {
    setState({ ...state, [name]: value });
  };
  const colors = ["#094E8F"];

  // const handleCategoryTreeChange = (value) => {
  //   handleChange("category_tree", value);
  // };

  const handleCategoryTreeChange = (value) => {
    const selected = categoryTree.find((item) => item.id === value);
    setState((prevState) => ({
      ...prevState,
      category_tree: value,
      category_tree_name: selected?.name || "",
    }));
  };

  // Handle form Submit
  const handleSubmit = async () => {
    const { category_tree_name, estimated_unit_price,  ...rest } = state;
    console.log('stdddate', state);
    
    try {
      setBtnLoading(true);
      let response;
      if (materialTypeId === null) {
        response = await postRequest("material-type/", rest);
      } else {
        response = await patchRequest(`material-type/${materialTypeId}/`, rest);
      }
      if (response.data.success) {
        SuccessNotificationMsg(
          materialTypeId === null
            ? t("material_type_added_successfully")
            : t("material_type_updated_successfully")
        );

        setState(initialState);
        setStateM((prev) => ({
          ...prev,
          page: 1,
        }));
        formRef.current.setFieldsValue(initialState);
        handleCancel();
        setReload((reload) => !reload);
        setBtnLoading(false);
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };
  return (
    <>
      <section className="grid-sec FormSection Container">
        <div className="FormBody">
          <Spin spinning={apiLoading}>
            <Form
              className="ModalForm"
              onFinish={handleSubmit}
              autoComplete="off"
              ref={formRef}
            >
              <Row gutter={[15]}>
                <Col md={8} className="TextFeild ">
                  <Form.Item
                    name="category_tree"
                    label={t("label_category")}
                    rules={[
                      {
                        required: true,
                        message: t("pl_category_tree"),
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      // showSearch
                      value={state.category_tree}
                      placeholder={t("pl_category_tree")}
                      optionFilterProp="children"
                      onChange={handleCategoryTreeChange}
                    >
                      {categoryTree &&
                        categoryTree.length > 0 &&
                        categoryTree.map((item) => (
                          <Select.Option
                            key={item.id}
                            value={item.id}
                            style={{ color: "black" }}
                          >
                            {item.name}
                          </Select.Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col md={8} className="TextFeild ">
                  <InputField
                    name="type_name"
                    label={t("pl_material_type4")}
                    placeholder={t("pl_enter_type")}
                    handleInputChange={handleInputChange}
                    rules={t("val_material_type")}
                    max={30}
                    // pattern={"^[a-zA-Z0-9 ]+$"}
                  />
                </Col>

                <Col md={8} className="TextFeild">
                  <Form.Item
                    name="hsn_code"
                    label={t("pl_hsn_code")}
                    prefix={<AddressLine />}
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_hsn_code")}</Trans>,
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      placeholder={t("pl_enter_hsn_code")}
                      onKeyPress={(e) => {
                        if (e.key === "." || e.key === "e") {
                          e.preventDefault(); // Prevent entering a dot
                        }
                      }}
                      onChange={(e) => handleChange("hsn_code", e.target.value)}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[15]}>
                <Col md={8} className="TextFeild">
                  <Form.Item
                    label={t("label_gst1")}
                    name="gst_rate"
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("pl_gst5")}</Trans>,
                      },
                      {
                        pattern: /^(100|[1-9]?[0-9])$/,
                        message: "Enter in range of 1-100",
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      placeholder={t("pl_gst")}
                      onKeyPress={(e) => {
                        if (e.key === "." || e.key === "e") {
                          e.preventDefault(); // Prevent entering a dot
                        }
                      }}
                      onChange={(e) => handleChange("gst_rate", e.target.value)}
                      prefix={<PercentageOutlined />}
                    />
                  </Form.Item>
                </Col>
                <Col md={8} className="TextFeild">
                  <Form.Item
                    label={t("label_gst_freight")}
                    name="gst_rate_freight"
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("pl_gst5")}</Trans>,
                      },
                      {
                        pattern: /^(100|[1-9]?[0-9])$/,
                        message: "Enter in range of 1-100",
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      placeholder={t("pl_gst_freight")}
                      onKeyPress={(e) => {
                        if (e.key === "." || e.key === "e") {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) =>
                        handleChange("gst_rate_freight", e.target.value)
                      }
                      prefix={<PercentageOutlined />}
                    />
                  </Form.Item>
                </Col>
                <Col md={8} className="TextFeild">
                  <Form.Item
                    label={t("label_escalation")}
                    name="escalation"
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_escalation")}</Trans>,
                      },
                      {
                        pattern: /^(100|[1-9]?[0-9])$/,
                        message: "Enter in range of 1-100",
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      placeholder={t("pl_escalation")}
                      rules={t("val_escalation")}
                      onKeyPress={(e) => {
                        if (e.key === "." || e.key === "e") {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) =>
                        handleChange("escalation", e.target.value)
                      }
                      prefix={<PercentageOutlined />}
                    />
                  </Form.Item>
                </Col>

                <Col md={8} className="TextFeild">
                  <Form.Item
                    name="sub_category"
                    label={
                      <span>
                        {t("pl_sub_category")}
                        <Tooltip
                          color={colors}
                          placement="top"
                          title={
                            <span style={{ color: "#fff" }}>
                              Example General Cement, Special Cement, RMC
                            </span>
                          }
                        >
                          <CircleIcon style={{ marginLeft: "6px" }} />
                        </Tooltip>
                      </span>
                    }
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_sub_category")}</Trans>,
                      },
                      // {
                      //   pattern: /^[a-zA-Z0-9 ]+$/,
                      //   message: "Enter in range of 1-100",
                      // },
                    ]}
                  >
                    <Input
                      name="sub_category"
                      max={30}
                      placeholder={t("pl_sub_category_example")}
                      onChange={handleInputChange}
                    />
                  </Form.Item>
                </Col>
                {(state.category_tree_name === "Structural steel" ||
                  state.category_tree_name === "Reinforcement steel") && (
                  <Col md={8} className="TextFeild">
                    <InputField
                      name="specification"
                      label={t("Grade And Quality")}
                      placeholder={t("Enter Grade And Quality")}
                      handleInputChange={handleInputChange}
                      max={30}
                    />
                  </Col>
                )}

                {state.category_tree_name === "Structural steel" && (
                  <Col md={8} className="TextFeild">
                    <InputField
                      name="dimension_standard"
                      label={t("Dimension")}
                      placeholder={t("Enter Dimension")}
                      handleInputChange={handleInputChange}
                      max={30}
                    />
                  </Col>
                )}
              </Row>

              <div className="ModalPopupFooter">
                <ButtonField
                  type="primary"
                  className="CancelGradiantBtn"
                  htmlType="button"
                  label={t("cancel")}
                  onClick={backToList}
                />
                <ButtonField
                  type="primary"
                  className="SaveGradiantBtn"
                  htmlType="Submit"
                  label={t("save")}
                  loading={btnLoading}
                />
              </div>
            </Form>
          </Spin>
        </div>
      </section>
    </>
  );
};
AddMaterialType.propTypes = {
  handleCancel: PropTypes.func,

  setReload: PropTypes.func,
  materialTypeId: PropTypes.number,
  modalKey: PropTypes.bool,
  setStateM: PropTypes.func,
};

export default AddMaterialType;
